import React, { useEffect, useState } from "react";
import { Hourglass } from "react-loader-spinner";
import { useParams } from "react-router-dom";
import axios from "axios";
import HeaderMobile from "../Component/MobileHader";
import Breadcrumb from "../Component/BradeCrum";
import Follows from "../Component/Follows";

const AboutUs = () => {
  const { title } = useParams();
  const [content, setContent] = useState([]);
 const [loading, setLoading] = useState(true);

 
  useEffect(() => {
    const fetchData = async () => {
      try {
        
        const response = await axios.get(
          `${process.env.REACT_APP_GRIPHOLD_API_URL}/api/auth/getCMS/cmss/${title}`
        );
        setContent(response.data);
      } catch (err) {
        console.error(err);
      }
    };
    fetchData();
  }, [title]);
    useEffect(() => {
      const handleLoading = async () => {
        setLoading(true); // Start loading
        window.scrollTo(0, 0);
  
        // Simulate loading for demonstration purposes
        await new Promise((resolve) => setTimeout(resolve, 2000));
  
        setLoading(false); // Stop loading
      };
  
      handleLoading();
    }, []);
  return (
    <React.Fragment>
      
      {loading ? (

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <Hourglass
            height={80}
            width={80}
            color="#01458e"
            ariaLabel="loading-content"
          />
        </div>
      ) : (
        <div>
        <HeaderMobile />
      <Breadcrumb heading={"About Us"} bTitle={"About Us"} />
        <div className="page-content">
          <div className="about-banner-section">
            <div className="container-lg container-fluid">
              <div className="aboutdescription">
              <div className="about-content-wrap">
                {content.length > 0 ? (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: `<style>tr { background-color: #f0f0f0 !important; border-bottom: none; }</style> ${content[0].Description}`,
                    }}
                  />
                ) : (
                  <p>No content available at the moment. Please check back later.</p>
                )}
               
              </div>
              </div>
              <Follows />
            </div>
          </div>
        </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default AboutUs;
